type TenantMembership = {
    tenantId: string,
};

export function resolvePreferredTeamTenantId(options: {
    memberships: TenantMembership[],
    currentTenantId?: string | null,
    tenantHint?: string | null,
}): string {
    const tenantIds = new Set(
        options.memberships
            .map(membership => String(membership.tenantId || '').trim())
            .filter(Boolean),
    );
    const tenantHint = String(options.tenantHint || '').trim();
    const currentTenantId = String(options.currentTenantId || '').trim();

    if (tenantHint && tenantIds.has(tenantHint)) {
        return tenantHint;
    }

    if (currentTenantId && tenantIds.has(currentTenantId)) {
        return currentTenantId;
    }

    return options.memberships.find(membership => tenantIds.has(membership.tenantId))?.tenantId || '';
}
